const tokenService = process.env.REACT_APP_TOKEN_SERVICE;
const tokenKey = process.env.REACT_APP_TOKEN_KEY;
const tokenExpire = process.env.REACT_APP_TOKEN_EXPIRE;

const baseURL = 'http://localhost:9000/api';

/**
 * Listado de endpoints del backend
 */
export default (csv, isDownload) => ({
  GET_DOCUMENT: `pe/${csv}/${isDownload}`,
  GET_VALIDATION: `pe/validar/${csv}`,
  GET_SIGNED_COPY: `pe/descargar-copia/${csv}`,
  SERVIDOR_RENO: `reno`,
  // Endpoint para gestionar el JWT
  GET_TOKEN: `${tokenService}?pubKey=${tokenKey}&exp=${tokenExpire}`,
  GET_LISTADO_NOTARIOS: `${baseURL}/notarios`,
});
